var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 113,
    viewBox: "0 0 111 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_3002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 12.1966,
    ry: 13.8436,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 49.9374 34.728)",
    fill: "url(#paint0_linear_24_3002)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 12.1966,
    ry: 13.8436,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 48.0398 36.1325)",
    fill: "#FDBF4B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_24_3002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.6228,
    ry: 12.0573,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 48.0398 36.1328)",
    fill: "#FA9F21"
  })), /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.04905,
    ry: 10.271,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 48.0397 36.1325)",
    fill: "url(#paint1_linear_24_3002)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_3002)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_24_3002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4 34.2949C52.4762 33.0393 51.5602 32.4363 51.0469 32.1034C50.5354 31.7707 49.7779 31.5226 49.7779 31.5226L50.0596 29.5705L48.9485 29.2639L48.6667 31.216L47.7777 30.9706L48.0595 29.0185L46.9355 28.7097L46.6537 30.6618L44.3018 30.0136L44.1351 31.1714C44.1351 31.1714 45.2961 31.4905 45.424 31.5272C45.5536 31.562 45.5438 31.6294 45.5371 31.6725C45.5306 31.7175 44.6826 37.6019 44.6703 37.6806C44.6598 37.7593 44.6515 37.8042 44.5441 37.7755C44.4348 37.7449 43.3108 37.436 43.3108 37.436L43.1258 38.7231L45.4016 39.3489L45.1316 41.2167L46.3445 41.55L46.6145 39.6822L47.3701 39.8908L47.1001 41.7586L48.2557 42.0775L48.5258 40.2097C48.5258 40.2097 48.8165 40.2895 49.3961 40.449C49.9739 40.6084 52.1177 40.6844 52.397 38.7435C52.6762 36.8026 51.054 35.9414 51.054 35.9414C51.054 35.9414 52.3221 35.5524 52.4 34.2949ZM50.1774 37.8577C50.0428 38.7869 49.0451 38.8361 48.8116 38.7708C48.5764 38.7054 46.745 38.2023 46.745 38.2023L47.1024 35.7219C47.1024 35.7219 48.8302 36.1982 49.2431 36.3108C49.6543 36.4252 50.3119 36.9285 50.1774 37.8577ZM50.1857 34.0671C50.0424 35.0562 49.0805 34.9897 48.7713 34.9058C48.462 34.8199 47.2621 34.4906 47.2621 34.4906L47.602 32.1282C47.602 32.1282 48.7446 32.4431 48.9796 32.5066C49.2149 32.572 50.3289 33.0779 50.1857 34.0671Z",
    fill: "#F99F1E"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_24_3002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 12.1966,
    ry: 13.8436,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 68.0126 27.3837)",
    fill: "url(#paint2_linear_24_3002)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 12.1966,
    ry: 13.8436,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 66.115 28.7883)",
    fill: "#FDBF4B"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_24_3002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.6228,
    ry: 12.0573,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 66.115 28.7885)",
    fill: "#FA9F21"
  })), /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.04905,
    ry: 10.271,
    transform: "matrix(-0.803691 0.595046 0.595046 0.803691 66.1149 28.7883)",
    fill: "url(#paint3_linear_24_3002)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_24_3002)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_24_3002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4752 26.9507C70.5514 25.695 69.6354 25.092 69.1221 24.7592C68.6106 24.4264 67.8531 24.1784 67.8531 24.1784L68.1348 22.2263L67.0237 21.9196L66.7419 23.8717L65.8529 23.6264L66.1347 21.6743L65.0107 21.3655L64.7289 23.3176L62.377 22.6694L62.2103 23.8272C62.2103 23.8272 63.3713 24.1462 63.4992 24.1829C63.6288 24.2178 63.619 24.2852 63.6123 24.3283C63.6058 24.3732 62.7578 30.2577 62.7455 30.3363C62.735 30.415 62.7267 30.46 62.6193 30.4313C62.51 30.4006 61.386 30.0918 61.386 30.0918L61.201 31.3789L63.4768 32.0046L63.2068 33.8724L64.4197 34.2058L64.6897 32.338L65.4453 32.5465L65.1753 34.4143L66.3309 34.7333L66.601 32.8655C66.601 32.8655 66.8917 32.9452 67.4713 33.1047C68.0491 33.2642 70.1929 33.3401 70.4722 31.3993C70.7514 29.4584 69.1292 28.5972 69.1292 28.5972C69.1292 28.5972 70.3973 28.2082 70.4752 26.9507ZM68.2526 30.5135C68.118 31.4427 67.1203 31.4919 66.8868 31.4265C66.6516 31.3612 64.8202 30.858 64.8202 30.858L65.1776 28.3776C65.1776 28.3776 66.9054 28.854 67.3183 28.9666C67.7295 29.081 68.3871 29.5843 68.2526 30.5135ZM68.2609 26.7228C68.1176 27.712 67.1557 27.6455 66.8465 27.5615C66.5372 27.4757 65.3373 27.1464 65.3373 27.1464L65.6771 24.784C65.6771 24.784 66.8198 25.0989 67.0548 25.1624C67.2901 25.2277 68.4041 25.7337 68.2609 26.7228Z",
    fill: "#F99F1E"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_24_3002)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32,
    width: 71,
    height: 57,
    rx: 10,
    fill: "url(#paint4_linear_24_3002)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_biii_24_3002)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 51,
    width: 25,
    height: 20,
    rx: 4,
    fill: "url(#paint5_linear_24_3002)",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_biii_24_3002)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 61.5,
    r: 3.5,
    fill: "url(#paint6_linear_24_3002)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_3002",
    x: 21.2355,
    y: 7.44263,
    width: 55.5062,
    height: 55.9751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.419608 0 0 0 0 0.0627451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_3002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_3002",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_24_3002",
    x: 36.8877,
    y: 24.5618,
    width: 22.3042,
    height: 23.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976302 0 0 0 0 0.525311 0 0 0 0 0.265365 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_3002"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_24_3002",
    x: 43.1259,
    y: 28.7097,
    width: 9.30347,
    height: 13.3677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.435294 0 0 0 0 0.0745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_3002"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_24_3002",
    x: 39.3107,
    y: 0.0983887,
    width: 55.5062,
    height: 55.9751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.419608 0 0 0 0 0.0627451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_3002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_3002",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_24_3002",
    x: 54.9629,
    y: 17.2175,
    width: 22.3042,
    height: 23.1421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.976302 0 0 0 0 0.525311 0 0 0 0 0.265365 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_3002"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_24_3002",
    x: 61.201,
    y: 21.3655,
    width: 9.30347,
    height: 13.3677,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.435294 0 0 0 0 0.0745098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_24_3002"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_24_3002",
    x: 0,
    y: 16,
    width: 111,
    height: 97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.807843 0 0 0 0 0.0352941 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_3002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_3002",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_biii_24_3002",
    x: 65,
    y: 41,
    width: 45,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24_3002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24_3002",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_24_3002"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_24_3002",
    result: "effect3_innerShadow_24_3002"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_24_3002",
    result: "effect4_innerShadow_24_3002"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_biii_24_3002",
    x: 4,
    y: -22,
    width: 167,
    height: 167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_24_3002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_24_3002",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_24_3002"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_24_3002",
    result: "effect3_innerShadow_24_3002"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_24_3002",
    result: "effect4_innerShadow_24_3002"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_3002",
    x1: 12.6167,
    y1: -11.0209,
    x2: 12.0754,
    y2: 27.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F48C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_3002",
    x1: 7.66744,
    y1: 5.54428,
    x2: 11.4835,
    y2: 21.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_24_3002",
    x1: 12.6167,
    y1: -11.0209,
    x2: 12.0754,
    y2: 27.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDE9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#F48C12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_24_3002",
    x1: 7.66744,
    y1: 5.54428,
    x2: 11.4835,
    y2: 21.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_24_3002",
    x1: 90.3901,
    y1: 63.1719,
    x2: 0.760174,
    y2: 63.3106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_24_3002",
    x1: 87.416,
    y1: 53.2266,
    x2: 87.416,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_24_3002",
    x1: 87.4765,
    y1: 58.7793,
    x2: 87.4765,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_3002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.979,
    height: 16.6866,
    fill: "white",
    transform: "matrix(-0.946559 0.322531 0.384341 0.923191 51.9105 26.1533)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_24_3002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.979,
    height: 16.6866,
    fill: "white",
    transform: "matrix(-0.946559 0.322531 0.384341 0.923191 69.9857 18.8091)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.ac2b6e77b3fab346d1029a3f7323720a.svg";
export { ForwardRef as ReactComponent };